export const EVENT_TYPES = {
  FRAME_READY: 'frame-ready',
  ACTION: 'action',
  AUTHORIZATION_CODE: 'authorization-code',
};
